export default __webpack_public_path__ + "static/media/logo.0f48d5dd.svg";